import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import ProductList from "../ProductList/ProductList";
import classes from "./Category.module.css";
import { useParams } from "react-router";

function Category(props) {
  // componentDidMount() {
  //     props.resetFilter();
  //     window.scrollTo(0, 0);
  //     //props.displayMenu(false);
  //     //console.log(props.products);
  // }

  // componentDidUpdate(prevProps, prevState) {
  //     window.scrollTo(0, 0);
  // }
  let { id } = useParams();
  useEffect(() => {
    window.scrollTo(0, 0);
  });

  //render(){

  // const index = parseInt(props.match.params.id);
  const index = parseInt(id);
  const cat = props.category(index);
  console.log(cat);
  const navigation = props.navigation(index);
  const hasNavigation = navigation.length > 0;
  let prevLink = "";
  let nextLink = "";
  if (hasNavigation) {
    if (index !== navigation[0]) prevLink = `/category/${index - 1}`;
    if (index !== navigation[1]) nextLink = `/category/${index + 1}`;
  }

  const title = props.title(index);
  const takeAwayOption = props.takeAwayOption(index);
  const products = props.products(index);
  //console.log(products);

  let priceBtns = null;
  if (takeAwayOption) {
    priceBtns = (
      <div className={classes.PriceBtns}>
        <p>Εμφάνιση Τιμών : </p>
        <button
          className={!props.takeAway ? classes.ShopBtnActive : classes.ShopBtn}
          onClick={() => props.setPrice(false)}
        >
          {
            //props.takeAway ? "Απόκρυψη τιμών Take Away" : "Εμφάνιση τιμών Take Away"
          }
          Καταστήματος
        </button>
        <button
          className={
            props.takeAway ? classes.TakeAwayBtnActive : classes.TakeAwayBtn
          }
          onClick={() => props.setPrice(true)}
        >
          {
            //props.takeAway ? "Απόκρυψη τιμών Take Away" : "Εμφάνιση τιμών Take Away"
          }
          Take Away
        </button>
      </div>
    );
  }

  let navigationBtns = (
    <div className={classes.InnerNavigation}>
      {prevLink !== "" ? (
        <Link to={prevLink}>
          <button>
            <img src="assets/icon/arrow_back.svg" alt="back arrow" />
          </button>
        </Link>
      ) : null}
      <Link to="/Menu">
        <button>
          <img src="assets/icon/grid.svg" alt="main menu" />
        </button>
      </Link>
      {nextLink !== "" ? (
        <Link to={nextLink}>
          <button>
            <img src="assets/icon/arrow_forward.svg" alt="forward arrow" />
          </button>
        </Link>
      ) : null}
    </div>
  );

  let topNavigation = (
    <div className={classes.TopNavigation}>
      <Link to="/Menu">
        <button>
          <img src="assets/icon/grid.svg" alt="main menu" />
        </button>
      </Link>
    </div>
  );

  let cat_filters = null;
  if (cat.hasOwnProperty("cat_filters")) {
    cat_filters = (
      <div className={classes.CategoryFilters}>
        <ul>
          {cat.cat_filters.map((filter) => (
            <li
              onClick={(f) => props.setFilter(filter)}
              className={props.filter === filter ? "active" : null}
              key={filter}
            >
              {filter}
            </li>
          ))}
        </ul>
      </div>
    );
  }

  let catImage = null;
  if (index >= 8 && index <= 19) {
    catImage = (
      <div className={classes.CategoryImage}>
        <img src={cat.img} />
      </div>
    );
  }

  let info = null;
  if (cat.hasOwnProperty("info")) {
    info = <h3 className={classes.CategoryInfo}>{cat.info}</h3>;
  }

  return (
    <div className={classes.Category}>
      {topNavigation}
      <div className={classes.CategoryTitle}>
        <h2>{title}</h2>
      </div>

      {catImage}

      {info}

      <div className="filters-wrapper">
        <div className="filters">{cat_filters}</div>
      </div>

      {
        //priceBtns
      }

      <ProductList
        setFilter={(filter) => props.setFilter(filter)}
        takeAway={props.takeAway}
        filter={props.filter}
        products={products}
      />

      <div className="filters-wrapper">
        <div className="filters">{cat_filters}</div>
      </div>

      {navigationBtns}

      <aside>
        <p>Στις τιμές περιλαμβάνεται ΦΠΑ</p>
        <p>
          Ο καταναλωτής δεν έχει υποχρέωση να πληρώσει εάν δεν λάβει το Νόμιμο
          παραστατικό στοιχείο (Απόδειξη ή Τιμολόγιο)
        </p>
      </aside>
    </div>
  );
  //}
}

export default Category;
